/*doc
---
title: ReadingChallengeBadge
name: reading_challenge_badge
category: React
---

A component for displaying the yearly challenge badge/image.

PROPS:

REQUIRED - challenge: a yearly challenge consisting of the challenge year,
the paths to the images required to display the badge,
boolean of whether the challenge is completed for the user
*/
import GrPropTypes from "../shared/gr_prop_types";
import GrComponentFactory from "../gr_component_factory";

export default GrComponentFactory.createClass({
  displayName: "ReadingChallengeBadge",

  propTypes: {
    challenge: GrPropTypes.readingChallenge().isRequired,
  },

  renderYearHeader(){
    return <span className="yearHeader">
             {this.props.challenge.year}
           </span>;
  },

  renderBookImage(){
    return <img src={this.props.challenge.images.badge} alt="" className="bookImg" />;
  },

  renderCompletedImage(){
    return <img src={this.props.challenge.images.completed} className="completedImg" />;
  },

  renderBadgeFooter(){
    return  <div className="challengeText">
              <div className="challengeText--reading">READING</div>
              <div>CHALLENGE</div>
            </div>;
  },

  render () {
    const challenge = this.props.challenge;
    return <div className="readingChallengeBadge">
             <div className={"badgeYear"} style={{ backgroundColor: `${challenge.primaryColor}` }}>
               { challenge.isFinished ? this.renderCompletedImage() : null }
               {this.renderYearHeader()}
               {this.renderBookImage()}
               {this.renderBadgeFooter()}
             </div>
           </div>;
  },
});
